<template>
  <div class="checked-modal">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="716px"
      :append-to-body="true"
    >
      <div class="modal-body">
        <div class="select-filter">
          <el-input
            style="width: 160px"
            placeholder="请输入查询"
            suffix-icon="el-icon-search"
            v-model="searchStr"
          >
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table
            :data="filterData"
            style="width: 100%"
            height="380px"
            @selection-change="handleSelectionChange"
            ref="checkedModalRef"
            :row-key="rowKey"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            >
            </el-table-column>
            <el-table-column
              v-for="item of tableConf"
              :key="item.colName"
              :prop="item.colName"
              :label="item.title"
            >
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CheckModal",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    tableConf: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: "name",
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchStr: "",
      pageData: {
        total: 0,
        page: 1,
        size: 10,
      },
      multipleSelection: [],
    };
  },
  methods: {
    showModal() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.checkedModalRef.clearSelection();
      });
    },
    changePage(page) {
      this.pageData.page = page;
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirmSelect() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
      } else {
        this.dialogVisible = false;
        this.$emit("selectOk", this.multipleSelection);
      }
    },
  },
  computed: {
    filterData() {
      return this.tableData.filter((item, index) => {
        if (
          this.pageData.size * (this.pageData.page - 1) <= index &&
          index < this.pageData.size * this.pageData.page
        ) {
          return true;
        }
      });
    },
  },
  watch: {
    tableData(val) {
      this.pageData.total = val.length;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .select-filter {
    margin-bottom: 14px;
  }
  .footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0px 24px 0px;
    .bottom-wrap {
      display: flex;
    }
    /deep/ .pagination-wrap {
      padding: 0px;
      text-align: left;
      position: relative;
      left: -10px;
    }
  }
}
</style>